import React from "react";
import { useLang } from "@/i18n";
import { HOME_COPY as C } from "@/data/homeContent";
import { HOME_MEDIA } from "@/data/homeMedia";
import { HomeMedia } from "./HomeMedia";
import { Reveal, SectionLabel, TextLink } from "./HomePrimitives";

export const HomeNaguara = () => {
  const { t } = useLang();
  const media = HOME_MEDIA.naguara;
  const hasMaterial = Boolean(media.image || media.video?.desktop || media.video?.mobile);
  return <section className="rh-naguara rh-wrap" data-testid="home-naguara">
    <Reveal className="rh-naguara-copy">
      <SectionLabel testId="home-naguara-heading" number="05">{t(C.naguaraLabel)}</SectionLabel>
      <p className="rh-naguara-name" data-testid="home-naguara-brand">NAGUARÀ<span>CAFÉS</span></p>
      <p className="rh-naguara-tagline" data-testid="home-naguara-tagline">{t(C.naguaraTitle)}</p>
      <p className="rh-body" data-testid="home-naguara-description">{t(C.naguaraBody)}</p>
      <div className="rh-naguara-links"><TextLink to="/naguara" testId="home-naguara-discover">{t(C.naguaraDiscover)}</TextLink><TextLink to="/tienda" testId="naguara-comprar-cafe-link">{t(C.shopCoffee)}</TextLink></div>
    </Reveal>
    <HomeMedia name="naguara" className="rh-naguara-media">{!hasMaterial && <div className="rh-material-mark" aria-hidden="true"><span>N</span><small>NAGUARÀ · CAFÉS</small></div>}</HomeMedia>
  </section>;
};

export const HomeExperience = () => {
  const { t } = useLang();
  return <section className="rh-experience" data-testid="home-experience">
    <div className="rh-experience-inner rh-wrap">
      <HomeMedia name="experience" sizes="(max-width: 767px) 100vw, 48vw" className="rh-experience-photo" />
      <Reveal className="rh-experience-copy">
        <SectionLabel testId="home-experience-heading" number="06">{t(C.experienceLabel)}</SectionLabel>
        <p className="rh-statement" data-testid="home-experience-statement">{t(C.experienceLine1)}<br /><em>{t(C.experienceLine2)}</em></p>
        <p className="rh-body">{t(C.experienceBody)}</p>
        <TextLink to="/menus-para-grupos" testId="join-grupos">{t(C.groupsLink)}</TextLink>
      </Reveal>
    </div>
  </section>;
};